import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { upgradeDocumentStorage } from "Routes/paths";

export const useShowWarningPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => {
    setShowPopup(true);
  }

  const closePopup = () => {
    setShowPopup(false);
  }

  return [showPopup, openPopup, closePopup];
}

const StorageWarningPopup = ({ showPopup, handleClose }) => {
  return (
    <>
      <Modal
        show={showPopup}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="FormPop"
      >
        <Modal.Header closeButton>
          <Modal.Title>⚠️ Storage Almost Full</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12">
              <p className="m-0">
                You're running low on storage space. To avoid interruptions in uploading new documents, consider freeing up space or{" "}
                <Link to={upgradeDocumentStorage}>purchasing additional storage</Link>.
              </p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="FormbtnWrpper justify-content-end d-flex gap-10">
          <Button
            className="d-flex align-items-center justify-content-center commonBtn btnSm"
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StorageWarningPopup;
